import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { KatDivider, KatLabel, KatPagination, } from "@amzn/katal-react";
import { ProductInfoResult } from "src/model/ProductMatch";
import ProductItemComponent from "src/components/product/ProductItemComponent";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { setMerchantProductDataQueryStart } from "src/actions/MerchantProductSearchAction";
import { setGeneralProductDataQueryStart } from "src/actions/GeneralProductSearchAction";
import LoadingStatusComponent from "src/components/common/LoadingStatusComponent";
import ErrorStatusComponent from "src/components/common/ErrorStatusComponent";
import MetricsUtil from "src/utils/MetricsUtil";
import { isLoginMode } from "src/config/Config";

export interface ProductListProps {
    countryCode: string,
    searchKey: string,
    productResults: ProductInfoResult,
    isMyOffer: boolean,
    inLoading: boolean,
    hasError: boolean,
    handleSelect: Function,
}

interface OwnProps {
    readonly metricsUtil?: MetricsUtil
}

interface DispatchProps {
    readonly dispatchGetMerchantProductPage: (countryCode: string, searchKey: string, pageOffset: number) => void,
    readonly dispatchGetGeneralProductPage: (countryCode: string, searchKey: string, pageOffset: number) => void
}

const mapDispatchToProps = (dispatch: Dispatch) => (
    bindActionCreators({
        dispatchGetMerchantProductPage: setMerchantProductDataQueryStart,
        dispatchGetGeneralProductPage: setGeneralProductDataQueryStart
    }, dispatch)
);

const connector = connect(null, mapDispatchToProps);

const MERCHANT_ITEM_PER_PAGE = 8;
const GENERAL_ITEM_PER_PAGE = 16;

type Props = ProductListProps & OwnProps & DispatchProps & WithTranslation;

export class ProductListComponent extends React.Component<Props, {}> {
    protected readonly metricsUtil: MetricsUtil;
    // Update selected page even failed to get page result
    private selectedPage: number;
    constructor(props: Props) {
        super(props);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.selectedPage = props.productResults ? props.productResults.currentPage : 1;

        if (this.props.metricsUtil) {
            this.metricsUtil = this.props.metricsUtil;
        } else {
            this.metricsUtil = MetricsUtil.getDefaultMetricUtil();
        }
    }

    handlePageChange(event: KatPagination.PageChangedEvent) {
        this.selectedPage = event.detail.page;
        if (this.props.isMyOffer) {
            if (this.metricsUtil) {
                this.metricsUtil.publishCounter("merchantPagination", "click");
            }
            this.props.dispatchGetMerchantProductPage(this.props.countryCode, this.props.searchKey,
                event.detail.page);
        } else {
            if (this.metricsUtil) {
                this.metricsUtil.publishCounter("generalPagination", "click");
            }
            this.props.dispatchGetGeneralProductPage(this.props.countryCode, this.props.searchKey,
                event.detail.page);
        }
    }

    render() {
        const { t, productResults, isMyOffer, inLoading, hasError } = this.props;
        if (this.metricsUtil) {
            this.metricsUtil.publishCounter(isMyOffer ? "merchantProducts" : "generalProducts", "count", productResults.products.length);
        }
        return (
            <div id="product-list" className="product-list">
                <div id="product-list-title" className="flexed">
                    {isMyOffer && <KatLabel text={t('SC_FBA_Calc_label_productsISell')} className="products-list-title-my" />}
                    {!isMyOffer && <KatLabel text={isLoginMode() ? t('SC_FBA_Calc_label_otherProductsOnAmazon') : t('SC_FBA_Calc_label_productsOnAmazon')} className="products-list-title-other" />}
                    <KatDivider variant="athens" className="product-list-divider" />
                </div>
                {inLoading ? (<LoadingStatusComponent />) :
                    (<>
                        {hasError ? (<ErrorStatusComponent description={t('SC_FBA_Calc_error_productMatchFailed')} />) :
                            (<>
                                {productResults.products.length === 0 ? (<ErrorStatusComponent description={isMyOffer ? t('SC_FBA_Calc_myproduct_emptyResult') : t('SC_FBA_Calc_product_emptyResult')} />) :
                                    (<>
                                        <div id="product-list-panel" className="product-list-panel">
                                            {
                                                productResults.products.map((product, index) => (
                                                    <ProductItemComponent product={product} key={index} handleSelect={this.props.handleSelect} />
                                                ))
                                            }
                                        </div>
                                    </>)
                                }
                            </>)
                        }
                        <div id="product-list-pagination" className="pagination">
                            <KatPagination totalItems={productResults.totalProductCount} itemsPerPage={isMyOffer ? MERCHANT_ITEM_PER_PAGE : GENERAL_ITEM_PER_PAGE}
                                page={this.selectedPage} onPageChanged={this.handlePageChange} />
                        </div>
                    </>)
                }
            </div>
        );
    }
}

export default withTranslation()(connector(ProductListComponent));